import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Form, Row } from "react-bootstrap";
import { Field, FormikProvider, useFormik } from "formik";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import * as Yup from "yup";
import { post } from "../../../helpers/api_helper";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { SVGICON } from "../../../constant/theme";

import {
  POST_GetPrintLabel,
  POST_GetPrintLabelList,
} from "../../../helpers/url_helper";
import { errorMessage, warningMessage } from "../CommonFunctions";

const PrintLabel = () => {
  const [showFilter, setShowFilter] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState("");
  const [orderBy, setOrderBy] = useState("asc");

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidFilterSubmit(values, formikHelpers),
    initialValues: {
      Search: "",
      CustomerName: "",
      ProjectNames: "",
      Address: "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidFilterSubmit,
    values: { Search, CustomerName, ProjectNames, Address },
  } = formikFilter;

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      CustomerName: CustomerName,
      ProjectNames: ProjectNames,
      Address: Address,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };

    await post(POST_GetPrintLabelList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        formik.setFieldValue("CustomerList", response?.List);

        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({});

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      CustomerList: [],
      labelList: [],
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    values: { CustomerList, labelList },
  } = formik;

  const handleValidSubmit = (values) => {};

  const getPrintLabel = async () => {
    // let selectedcount = 0;
    // CustomerList?.map((item, indx) =>
    //   item.ListOfCustomerProjects.length > 0
    //     ? item.ListOfCustomerProjects?.map((itemsub, indx) => {
    //         if (
    //           itemsub?.ListOfCustomerProjectAddress?.filter(
    //             (x) => x.IsSelected == true
    //           )?.length > 0
    //         ) {
    //           selectedcount = selectedcount + 1;
    //         }
    //       })
    //     : ""
    // );

    // if (selectedcount == 0) {
    //   warningMessage("Please select atleast one Address to Print...");
    // }

    const hasSelectedAddress = CustomerList?.some((customer) =>
      customer.ListOfCustomerProjects?.some((project) =>
        project.ListOfCustomerProjectAddress?.some(
          (address) => address.IsSelected
        )
      )
    );

    if (!hasSelectedAddress) {
      warningMessage("Please select at least one Address to Print...");
    } else {
      formik.setFieldValue("labelList", []);
      setIsLoading(true);
      let payload = {
        List: CustomerList,
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      };

      post(POST_GetPrintLabel, payload)
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setFieldValue("labelList", response?.List);
          } else {
            errorMessage(response?.Message);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (labelList?.length > 0) {
      Promise.all(
        labelList?.map((item, indx) => {
          const iframe = document.getElementById(`iFrame-${indx}`);
          if (iframe) {
            iframe.contentWindow.print();
          }
        })
      );
      formik.setFieldValue(
        "CustomerList",
        CustomerList.map((item) => ({
          ...item,
          ListOfCustomerProjects: item?.ListOfCustomerProjects.map(
            (itemSub) => ({
              ...itemSub,
              ListOfCustomerProjectAddress:
                itemSub?.ListOfCustomerProjectAddress.map((itemSubParent) => ({
                  ...itemSubParent,
                  IsSelected: false,
                })),
            })
          ),
        }))
      );
    }
  }, [labelList]);

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Print Label</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="Customer Name"
                              name="CustomerName"
                              placeholder={"Search here..."}
                              component={CustomInput}
                              autoFocus
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Project Name"
                              name="ProjectNames"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Address"
                              name="Address"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>

                          <Col lg={3}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  className="btn btn-primary btn-sm me-2"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-sm "
                                  onClick={(e) => {
                                    getPrintLabel();
                                  }}
                                >
                                  {SVGICON.Printer} Print Label
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <FormikProvider value={formik}>
                  <Form onSubmit={formik.handleSubmit}>
                    <div
                      id="printlabelList-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="printlabelList-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="3%">Sr No</th>
                            <th
                              style={{
                                width: "25%",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                handleClickSorting("CustomerName");
                              }}
                            >
                              Customer Name{" "}
                              <span className="ml-1">
                                {sortBy == "CustomerName" ? (
                                  orderBy == "desc" ? (
                                    <i
                                      className="fa fa-arrow-down ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-arrow-up ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  )
                                ) : (
                                  <i
                                    className="fa fa-sort ms-2 fs-14"
                                    style={{ opacity: "0.3" }}
                                  />
                                )}
                              </span>
                            </th>

                            <th
                              style={{
                                width: "30%",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                handleClickSorting("ProjectNames");
                              }}
                            >
                              Project Name{" "}
                              <span className="ml-1">
                                {sortBy == "ProjectNames" ? (
                                  orderBy == "desc" ? (
                                    <i
                                      className="fa fa-arrow-down ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-arrow-up ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  )
                                ) : (
                                  <i
                                    className="fa fa-sort ms-2 fs-14"
                                    style={{ opacity: "0.3" }}
                                  />
                                )}
                              </span>
                            </th>
                            <th
                              style={{
                                width: "35%",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                handleClickSorting("ProjectAddress");
                              }}
                            >
                              Address{" "}
                              <span className="ml-1">
                                {sortBy == "ProjectAddress" ? (
                                  orderBy == "desc" ? (
                                    <i
                                      className="fa fa-arrow-down ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-arrow-up ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  )
                                ) : (
                                  <i
                                    className="fa fa-sort ms-2 fs-14"
                                    style={{ opacity: "0.3" }}
                                  />
                                )}
                              </span>
                            </th>
                            <th
                              style={{
                                width: "7%",
                                cursor: "pointer",
                                textAlign: "left",
                              }}
                            ></th>
                          </tr>
                        </thead>
                        <tbody>
                          {CustomerList?.length > 0 ? (
                            CustomerList?.map((item, indx) => (
                              <>
                                <tr key={indx}>
                                  <td
                                    rowSpan={
                                      item?.ListOfCustomerProjects?.length + 1
                                    }
                                  >
                                    {indx + 1}
                                  </td>
                                  <td
                                    rowSpan={
                                      item?.ListOfCustomerProjects?.length + 1
                                    }
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    {item.CustomerName}
                                  </td>
                                </tr>
                                {item?.ListOfCustomerProjects?.length > 0
                                  ? item?.ListOfCustomerProjects?.map(
                                      (itemCP, indxCP) => (
                                        <>
                                          <tr>
                                            <td>{itemCP.ProjectName}</td>

                                            <td>
                                              {itemCP
                                                ?.ListOfCustomerProjectAddress
                                                ?.length > 0
                                                ? itemCP?.ListOfCustomerProjectAddress?.map(
                                                    (itemCPA, indxCPA) => (
                                                      <>
                                                        <Field
                                                          type="text"
                                                          name={`CustomerList.[${indx}].ListOfCustomerProjects.[${indxCP}].ListOfCustomerProjectAddress.[${indxCPA}].Address`}
                                                          component={
                                                            CustomTextArea
                                                          }
                                                          noMarginBottom={
                                                            indxCPA <
                                                            itemCP
                                                              ?.ListOfCustomerProjectAddress
                                                              ?.length -
                                                              1
                                                              ? false
                                                              : true
                                                          }
                                                          rows={3}
                                                        />
                                                      </>
                                                    )
                                                  )
                                                : ""}
                                            </td>
                                            <td style={{ textAlign: "left" }}>
                                              <div className="d-flex align-item-center flex-column">
                                                {itemCP
                                                  ?.ListOfCustomerProjectAddress
                                                  ?.length > 0
                                                  ? itemCP?.ListOfCustomerProjectAddress?.map(
                                                      (itemCPA, indxCPA) => (
                                                        <>
                                                          <div
                                                            className={`align-self-center ${
                                                              itemCP
                                                                ?.ListOfCustomerProjectAddress
                                                                ?.length > 1 &&
                                                              indxCPA !== 0
                                                                ? "mt-5"
                                                                : ""
                                                            }`}
                                                          >
                                                            <input
                                                              type="checkbox"
                                                              className="form-check-input"
                                                              id={`chkIsSelected${indxCPA}`}
                                                              name={`chkIsSelected${indxCPA}`}
                                                              checked={
                                                                itemCPA?.IsSelected
                                                              }
                                                              onChange={(e) => {
                                                                formik.setFieldValue(
                                                                  `CustomerList.[${indx}].ListOfCustomerProjects.[${indxCP}].ListOfCustomerProjectAddress.[${indxCPA}].IsSelected`,
                                                                  e?.target
                                                                    ?.checked
                                                                );
                                                              }}
                                                            />
                                                          </div>
                                                        </>
                                                      )
                                                    )
                                                  : ""}
                                              </div>
                                            </td>
                                          </tr>
                                        </>
                                      )
                                    )
                                  : ""}
                              </>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={5} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="d-sm-flex text-center justify-content-between align-items-center">
                        <CustomSizePerPage
                          getData={getData}
                          currentSizePerPage={currentSizePerPage}
                        />
                        <div className="dataTables_info">
                          Showing{" "}
                          {recordCount > 0
                            ? (currentPage - 1) * currentSizePerPage + 1
                            : 0}{" "}
                          to{" "}
                          {recordCount > currentPage * currentSizePerPage
                            ? currentPage * currentSizePerPage
                            : recordCount}{" "}
                          of {recordCount} entries
                        </div>
                        <CustomPaginationButtons
                          totalPages={recordCount / currentSizePerPage}
                          currentPage={currentPage}
                          currentSizePerPage={currentSizePerPage}
                          getData={getData}
                        />
                      </div>
                    </div>
                  </Form>
                </FormikProvider>
              </div>
            </div>
          </Spin>
        </div>
      </div>

      <div style={{ display: "none" }}>
        {labelList?.map((item, idx) => (
          <iframe
            id={`iFrame-${idx}`}
            title="Print Label"
            width="100%"
            style={{ height: "100vh", display: "none" }}
            frameBorder="0"
            srcDoc={item?.HTMLContents}
          ></iframe>
        ))}
      </div>
    </>
  );
};

export default PrintLabel;
